import http from "../http-common";

const XRVA_API_PREFIX = "/api";
const XRVA_API_KEY = process.env.REACT_APP_API_KEY || "test";
const XRVA_DEFAULT_TIMEOUT_MS = 15000;

function buildHeaders(opts = {}) {
  return {
    ...(opts.headers || {}),
    ...(opts.json ? { "Content-Type": "application/json" } : {}),
    ...(opts.auth ? { "x-api-key": XRVA_API_KEY } : {}),
  };
}

async function xrvaRequest(path, opts = {}) {
  const method = opts.method || "GET";
  const headers = buildHeaders(opts);

  try {
    const res = await http.request({
      url: `${XRVA_API_PREFIX}${path}`,
      method,
      headers,
      data: opts.json ? opts.json : opts.body,
      timeout: opts.timeoutMs || XRVA_DEFAULT_TIMEOUT_MS,
      // IMPORTANT: send cookies with every call
      withCredentials: true,
      // If you later add CSRF, set these to match server:
      // xsrfCookieName: "csrfToken",
      // xsrfHeaderName: "x-csrf-token",
    });
    return res.data ?? {};
  } catch (err) {
    if (err.code === "ECONNABORTED") throw new Error("Request timeout");
    const status = err.response?.status;
    const statusText = err.response?.statusText;
    const data = err.response?.data;
    throw new Error(
      `${status || ""} ${statusText || ""} ${JSON.stringify(data)}`.trim()
    );
  }
}

/* ---------- Health ---------- */
export const xrvaGetHealth = () => xrvaRequest("/health");

/* ---------- Streams ---------- */
export const xrvaListStreams = () => xrvaRequest("/streams", { auth: true });

export const xrvaCreateStream = (body) =>
  xrvaRequest("/streams", { method: "POST", auth: true, json: body });

export const xrvaDeleteStream = (id) =>
  xrvaRequest(`/streams/${id}`, { method: "DELETE", auth: true });

/* ---------- AV toggles + status ---------- */
export const xrvaAvStatus = () => xrvaRequest("/stream/status", { auth: true });

export const xrvaStartVideo = (payload = {}) =>
  xrvaRequest("/stream/video/start", {
    method: "POST",
    auth: true,
    json: payload,
  });

export const xrvaStartVideoAudio = (payload = {}) =>
  xrvaRequest("/stream/video/start-and-audio", {
    method: "POST",
    auth: true,
    json: payload,
  });

export const xrvaStopVideo = () =>
  xrvaRequest("/stream/video/stop", { method: "POST", auth: true });

export const xrvaStartAudio = (payload = {}) =>
  xrvaRequest("/stream/audio/start", {
    method: "POST",
    auth: true,
    json: payload,
  });

export const xrvaStopAudio = () =>
  xrvaRequest("/stream/audio/stop", { method: "POST", auth: true });

export const xrvaKillAll = () =>
  xrvaRequest("/stream/kill-all", { method: "POST", auth: true });

export const playingVideoInfo = () => {
  return http.get("/api/system/db-info");
};
